// extracted by mini-css-extract-plugin
export var statItem = "_j7-1";
export var statsRow = "_j7-0";